import ReferenceCard from './ReferenceCard.component';

export default ReferenceCard;